import { render, staticRenderFns } from "./NewsletterPage.vue?vue&type=template&id=4a3e66b3&"
import script from "./NewsletterPage.vue?vue&type=script&lang=ts&"
export * from "./NewsletterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports